module.exports = __webpack_public_path__ + "static/pic03-800f4ea498b1f5b82cc05a327debeabd.jpg";